export const measureContentHeight = (
  content: Pick<HTMLElement, 'offsetWidth' | 'innerHTML'>
): number => {
  const tempContainer = document.createElement('div');
  tempContainer.style.position = 'absolute';
  tempContainer.style.visibility = 'hidden';
  tempContainer.style.height = 'auto';
  tempContainer.style.width = content.offsetWidth + 'px';
  tempContainer.style.pointerEvents = 'none';

  tempContainer.innerHTML = content.innerHTML;
  document.body.appendChild(tempContainer);

  const naturalHeight = tempContainer.scrollHeight;

  document.body.removeChild(tempContainer);
  return naturalHeight;
};
